import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { observer } from 'mobx-react';
import { injectIntl } from 'react-intl';
import PrimaryButtonComponent from 'common/components/PrimaryButtonComponent/PrimaryButtonComponent';
import ContentStore from 'stores/Content.store';
import {
  IssueOfSharesModelExtractor,
  AnnualReportModelExtractor,
  OtherReportModelExtractor,
  EmptyReportModelExtractor
} from './ReportBox.utils';
import styles from './ReportBox.module.scss';

@injectIntl
@observer
export default class ReportBox extends Component {
  static propsTypes = {
    className: PropTypes.string
  };

  static defaultProps = {
    className: ''
  };

  getDataExtractor(model) {
    if (model.issueOfShare.isActive)
      return new IssueOfSharesModelExtractor(model.issueOfShare.data);

    if (model.annualReport.isActive)
      return new AnnualReportModelExtractor(model.annualReport.data);

    if (!!model.otherReport)
      return new OtherReportModelExtractor(model.otherReport.data);

    return new EmptyReportModelExtractor();
  }

  render() {
    const { className } = this.props;

    if (!ContentStore.isLoaded) {
      return null;
    }

    const {
      content: {
        report,
        annualReport,
        system: { language },
        IssueOfShares,
        IsIssueOfSharesActive
      }
    } = ContentStore;

    const { year, period, quarter } = report;

    const extractorModels = {
      issueOfShare: {
        isActive: !!IsIssueOfSharesActive && language === 'pl',
        data: IssueOfShares
      },
      annualReport: { isActive: !!annualReport, data: annualReport },
      otherReport: { isActive: !!report, data: { year, period, quarter } }
    };

    var dataExtractor = this.getDataExtractor(extractorModels);
    const texts = dataExtractor.extract();

    return !!texts ? (
      <div className={className}>
        <h3 className={styles.ReportTitle}>{texts.title}</h3>
        <p className={styles.ReportParagraph}>{texts.description}</p>
        <PrimaryButtonComponent
          openNewTab
          className={styles.ReportBoxButton}
          text={texts.label}
          link={texts.url}
        />
      </div>
    ) : (
      <></>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/Home/Sections/Intro/Components/ReportBox/ReportBox.js